import { firestoreTimestampToDate } from "../utils/obejct-diff"
import { ConditionType, IDependencyMapping } from "./db-dependencies"
import { NetworkConstants } from "./network.constants"

export class HuntingEvent {

    public static className = "HuntingEvent"
    public className = "HuntingEvent"

    public identifier: string|undefined = undefined
    public contextId: string|undefined = undefined
    public date: Date|undefined = undefined
    public name: string|undefined = undefined
    public active: boolean|undefined = false
    public treibenCount: string|undefined = undefined
    public huntingDistrictId: string|undefined = undefined
    public huntingDistrictName: string|undefined = undefined
    public comment: string|undefined = undefined
    
    // from eventInvitation info site referral
    siteReferralIdentifier: string|undefined
    siteReferralTitle: string|undefined
    siteReferralURL: string|undefined

    updateTimestamp: Date|undefined = undefined
    creationDate: Date|undefined = undefined
    _structureVersion: string|undefined = undefined

    constructor() {}

    setFromAny(element: any) {
        const {
            identifier,
            contextId,
            date,
            name, 
            active, 
            treibenCount,
            huntingDistrictId,
            updateTimestamp,
            creationDate,
            _structureVersion,
            comment,
            huntingDistrictName
        } = element
        this.identifier = identifier ? identifier : this.identifier
        this.contextId = contextId ? contextId : this.contextId
        this.creationDate = firestoreTimestampToDate(creationDate ? creationDate: this.creationDate)
        this.updateTimestamp = firestoreTimestampToDate(updateTimestamp ? updateTimestamp : this.updateTimestamp)
        this.date = firestoreTimestampToDate(date ? date : this.date)
        this.name = name ? name : this.name
        this.active = active ? active : this.active
        this.treibenCount = treibenCount ? treibenCount : this.treibenCount
        this.huntingDistrictId = huntingDistrictId ? huntingDistrictId : this.huntingDistrictId
        this._structureVersion = _structureVersion ? _structureVersion : this._structureVersion
        this.comment = comment ? comment : this.comment
        this.huntingDistrictName = huntingDistrictName ? huntingDistrictName : this.huntingDistrictName
    }

    searchFilter(filter: string): boolean {
        const str = `${this.name}`.toLowerCase()
        return str.includes(filter)
    }

    getListItemTitle(): string {
        return this.name ? this.name : 'No name configured'
    }

    replacerFn(key: string) {
        return true
    }
}

export const DependencyEventToEventInvitation: IDependencyMapping = {
    collectionName: NetworkConstants.COLLECTION_EVENT_INV,
    mapping: new Map<string, string>([
        ["name", "eventName"],
        ["date", "eventDate"],
        ["huntingDistrictId", "huntingDistrictId"],
        ["huntingDistrictName", "huntingDistrictName"]
    ]),
    getQuery: (firestore: any, origin: any, now: Date|null): any => {
        return (now != null) ? firestore.collection(NetworkConstants.COLLECTION_EVENT_INV)
            .where('eventId', '==', origin['identifier'])
            .where('eventDate', '>=', now)
            :
            firestore.collection(NetworkConstants.COLLECTION_EVENT_INV)
            .where('eventId', '==', origin['identifier'])
    },
    getDoc: (firestore: any, identifier: string) => {
        return null
    }
}